module.exports = "<div class=\"panel-group\" role=\"tablist\" aria-multiselectable=\"true\">\n    <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/accordion/accordion.template.html
// module id = 999
// module chunks = 0